import { usePathname } from 'next/navigation'
import { FC } from 'react'

import { SidebarTooltip } from '@/components/widgets/sidebar/ui/SidebarTooltip'

import { SidebarNavItemProps } from './Sidebar.types'
import { SidebarNavItemActivator } from './SidebarNavItemActivator'

type Props = SidebarNavItemProps

const SidebarNavItem: FC<Props> = ({
  href,
  icon,
  activeIcon,
  name,
  count,
  className,
  onClick,
  isActive,
  showDot,
  isSidebarExpanded
}) => {
  const currentRoute = usePathname()
  const isActiveRoute = href === currentRoute

  return (
    <SidebarTooltip
      isSidebarExpanded={isSidebarExpanded}
      name={name}
      renderActivator={tooltipProps => (
        <SidebarNavItemActivator
          href={href}
          icon={icon}
          activeIcon={activeIcon}
          name={name}
          count={count}
          className={className}
          onClick={onClick}
          isActive={isActive}
          showDot={showDot}
          isSidebarExpanded={isSidebarExpanded}
          isActiveRoute={isActiveRoute}
          tooltipProps={tooltipProps as Record<string, unknown>}
        />
      )}
    />
  )
}

export { SidebarNavItem }
